import React from "react";
// import Logo from "../assets/photvanish-logo.png"; 

const HeroSection: React.FC = () => {
  return (
    <section className="w-full px-6 py-10 mb-5 flex flex-col items-center text-center mx-auto">
      {/* Logo + Brand Name */}
      {/* <div className="flex items-center justify-center space-x-2 mb-4"> */}
      {/* <img
          src={Logo}
          alt="PhotVanish"
          className="h-8 w-auto"
        /> */}
      {/* <span className="text-lg font-semibold text-gray-900">PhotVanish</span> */}
      {/* </div> */}

      {/* Main Heading */}
      <div className="w-full max-w-[1320px] mx-auto px-4">
        <h1 className="text-3xl md:text-5xl text-left md:text-center  font-poppins font-extrabold text-[#242424] mb-4">
          Remove the background from your image for free.
        </h1>

        <p className="text-sm md:text-lg text-left md:text-center font-poppins font-medium opacity-90 text-[#242424]">
          PhotVanish helps you remove backgrounds from your photos in seconds,
          plus offers powerful tools to enhance, resize, and transform your images
          with ease. Create stunning visuals quickly and hassle-free.
        </p>
      </div>
      

    </section>
  );
};

export default HeroSection;
